




































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { isMediaFile } from "@/lib/fileHelpers";
import { PostFileData } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import PostFileThumbnail from "../../../PostFileThumbnail";
import PreviewListItem from "../PreviewListItem";

interface Lists {
  thumbnails: PostFileData[];
  rows: PostFileData[];
}

@Component({
  name: "PreviewSetupView",
  components: { PostFileThumbnail, PreviewListItem, BaseConfirm, BaseButton, BaseIcon, CustomScroll },
})
export default class PreviewSetupView extends Vue {
  @Prop({ type: Array, required: true })
  public readonly fileList!: PostFileData[];

  @Prop({ type: Boolean, required: true })
  public readonly show!: boolean;

  public saving: boolean = false;

  public publicRecord: Record<string, boolean> = {};

  public get lists(): Lists {
    const initialLists: Lists = { thumbnails: [], rows: [] };
    return this.fileList.reduce((out, postFile) => {
      if (isMediaFile(postFile)) out.thumbnails.push(postFile);
      else out.rows.push(postFile);
      return out;
    }, initialLists);
  }

  @Watch("fileList", { immediate: true })
  public watchFileList(fileList: PostFileData[]) {
    this.getPublicRecord(fileList);
  }

  @Watch("show")
  public watchShow(show: boolean) {
    if (!show) return;
    this.getPublicRecord(this.fileList);
  }

  public getPublicRecord(fileList: PostFileData[]) {
    this.publicRecord = fileList.reduce<Record<string, boolean>>((out, i) => {
      if (this.publicRecord.hasOwnProperty(i.id)) out[i.id] = this.publicRecord[i.id];
      else out[i.id] = i.public;
      return out;
    }, {});
  }

  public onPublicChange(postId: string) {
    if (this.saving) return;
    this.$set(this.publicRecord, postId, !this.publicRecord[postId]);
  }

  public onSave() {
    this.saving = true;
    this.$emit("save", this.publicRecord, this.reset);
  }

  public onCancel() {
    this.reset();
    this.$emit("cancel");
  }

  public reset() {
    this.saving = false;
    this.publicRecord = {};
  }
}
